import React from 'react'
import styled from 'styled-components'

const MainContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 200px);
`

const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
  line-height: 1.5;
  text-align: justify;

  span.text-magenta {
    color: ${props => props.theme.colors.magenta};
  }
`

const SectionContent = styled.p`
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
  line-height: 1.5;
  text-align: justify;

  span.text-bold, &.text-bold {
    font-weight: 400;
  }

  span.text-magenta {
    color: ${props => props.theme.colors.magenta};
  }
`

const CustomSoftwareForStartups = () => {
  return (
    <MainContainer>
      <SectionContent>
      In today’s fast-paced digital world, startups and small businesses need software solutions that grow with them. While off-the-shelf software might seem like a quick and affordable option, it often fails to meet the unique needs of a growing business. Custom software development provides tailored solutions, scalability, and long-term cost savings, making it the best investment for startups and small businesses.
      </SectionContent>
      <SectionContent>
      At <span className='text-magenta text-bold'>Intellicubix</span>, we specialize in building custom applications that empower businesses to streamline operations, enhance customer experiences, and scale efficiently. Let’s explore why custom software is the right choice for your business.
      </SectionContent>
      <SectionTitle>The Limitations of Off-the-Shelf Software</SectionTitle>
      <SectionContent>
      Many businesses start with off-the-shelf solutions because they appear cost-effective and easy to implement. However, as businesses grow, these tools often become restrictive and inefficient. Here’s why:
      </SectionContent>
      <SectionContent>
      <span className='text-bold'>🚫 Limited Customization –</span> One-size-fits-all software may not align with your business’s specific workflows.
      </SectionContent>
      <SectionContent>
      <span className='text-bold'>🚫 Scalability Issues –</span> As your business grows, you may outgrow the software’s capabilities.
      </SectionContent>
      <SectionContent>
      <span className='text-bold'>🚫 Hidden Costs –</span> Licensing fees, additional features, and user limits add up over time.
      </SectionContent>
      <SectionContent>
      <span className='text-bold'>🚫 Lack of Integration –</span> Generic software may not integrate with other tools you rely on.
      </SectionContent>
      <SectionTitle>Why Custom Software is the Best Investment</SectionTitle>
      <SectionContent className='text-bold'>
      ✅ Tailored to Your Business Needs
      </SectionContent>
      <SectionContent>
      Custom software is designed specifically for your workflows, ensuring seamless operations and efficiency. It grows with your business and adapts to new challenges.
      </SectionContent>
      <SectionContent className='text-bold'>
      ✅ Scalability and Flexibility
      </SectionContent>
      <SectionContent>
      Unlike pre-built solutions, custom applications can be scaled and upgraded as your business expands. No need to switch to new software every few years—your system evolves with you.
      </SectionContent>
      <SectionContent className='text-bold'>
      ✅ Long-Term Cost Savings
      </SectionContent>
      <SectionContent>
      While custom software requires an initial investment, it eliminates recurring licensing fees and unnecessary feature costs, making it a cost-effective solution in the long run.
      </SectionContent>
      <SectionContent className='text-bold'>
      ✅ Seamless Integration with Existing Tools
      </SectionContent>
      <SectionContent>
      Custom applications are built to integrate smoothly with your existing software stack, making business operations more efficient.
      </SectionContent>
      <SectionContent className='text-bold'>
      ✅ Better Security and Compliance
      </SectionContent>
      <SectionContent>
      With custom software, you get enhanced security features tailored to your business needs, ensuring data protection and compliance with industry regulations.
      </SectionContent>
      <SectionTitle>How Custom Software Helps Small Businesses & Startups Succeed</SectionTitle>
      <SectionContent>
      <span className='text-bold'>🚀 Automates Business Operations –</span> Reduces manual work, streamlines workflows, and increases efficiency.
      </SectionContent>
      <SectionContent>
      <span className='text-bold'>📈 Improves Customer Experience –</span> Personalized apps provide better user experiences, leading to higher customer retention.
      </SectionContent>
      <SectionContent>
      <span className='text-bold'>💰Grows With Your Business –</span> Custom software is designed for scalability, ensuring it remains useful as your company expands.
      </SectionContent>
      <SectionContent>
      <span className='text-bold'>🔗 Competitive Advantage –</span> Stand out with a unique, tailor-made digital solution that meets your customers' specific needs.
      </SectionContent>
      <SectionTitle>How <span className='text-bold text-magenta'>Intellicubix</span> Can Help You Build Custom Software</SectionTitle>
      <SectionContent>
      At <span className='text-magenta text-bold'>Intellicubix</span>, we develop custom web and mobile applications tailored to your business goals. Whether you need a CRM, e-commerce platform, internal management tool, or automation software, our team is here to help.
      </SectionContent>
    </MainContainer>
  )
}

export default CustomSoftwareForStartups